
export const handleErrorNavigation = (error: any, navigate: any, t: any) => {
    const errorCodes = {
        401: {
            errorCode: "warning",
            errorTitle: t("LANDING.UNAUTHORIZED_DEFAULT"),
            errorDescription: "Authorization has been denied for this request.",
            path: '/not-found'
        },
        400: {
            errorCode: "",
            errorTitle: t("MICROSITE.URN_INVALID"),
            errorDescription: "",
            path: '/not-found'
        },
        403: {
            errorCode: "",
            errorTitle: t("MICROSITE.URN_INVALID"),
            errorDescription: "",
            path: '/not-found'
        },
        404: {
            errorCode: "warning",
            errorTitle: t("MICROSITE.URN_INVALID"),
            errorDescription: "",
            path: '/not-found'
        },
        410: {
            errorCode: "",
            errorTitle: t("MICROSITE.URN_INVALID"),
            errorDescription: "",
            path: '/not-found'
        },
        423: {
            errorCode: "",
            errorTitle: t("AUTH2FA.ERROR_ACCOUNT_LOCKED") + " " + process.env.REACT_APP_HELP_PHONE,
            errorDescription: "",
            path: '/unauthorised'
        },
        500: {
            errorCode: "",
            errorTitle: t("GLOBAL.NOTFOUND_DEFAULT"),
            errorDescription: "",
            path: '/not-found'
        },
        501: {
            errorCode: "",
            errorTitle: t("MICROSITE.URN_INVALID"),
            errorDescription: "",
            path: '/not-found'
        }
    };

    const errorInfo = errorCodes[error.status];
    
    if (errorInfo) {
        const navParams = {
            state: {
                errorCode: "",
                errorTitle: errorInfo.title,
                errorDescription: errorInfo.description
            }
        };
        console.log(navParams);
        navigate(errorInfo.path, navParams);
    } else {
        const defaultNavParams = {
            state: {
                errorCode: "",
                errorTitle: t("MICROSITE.URN_INVALID"),
                errorDescription: ""
            }
        };
        navigate('/not-found', defaultNavParams);
    }
};
